import Base from './Base';
import WebskyServicesAnalytics from '../WebskyServicesAnalytics';
class Nas extends Base {
    constructor(orderBeforeChange, orderAfterChange) {
        super(orderBeforeChange, orderAfterChange);
    }
    createServicesTravellersMap(services = []) {
        return new Map(services.map(service => [service.product.id, new Set(service.travellers.map(traveller => traveller.id))]));
    }
    diff() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        const added = [];
        const removed = [];
        const servicesMap = new Map((_e = (_d = (_c = (_b = (_a = this.orderAfterChange) === null || _a === void 0 ? void 0 : _a.additionalServices) === null || _b === void 0 ? void 0 : _b.nas) === null || _c === void 0 ? void 0 : _c.services) === null || _d === void 0 ? void 0 : _d.map(service => [service.id, service])) !== null && _e !== void 0 ? _e : []);
        const travellersMap = new Map((_h = (_g = (_f = this.orderAfterChange) === null || _f === void 0 ? void 0 : _f.travellers) === null || _g === void 0 ? void 0 : _g.map(traveller => [traveller.id, traveller])) !== null && _h !== void 0 ? _h : []);
        const beforeServicesTravellersIdsMap = this.createServicesTravellersMap((_l = (_k = (_j = this.orderBeforeChange) === null || _j === void 0 ? void 0 : _j.additionalServices) === null || _k === void 0 ? void 0 : _k.nas) === null || _l === void 0 ? void 0 : _l.selectedServices);
        const afterServicesTravellersIdsMap = this.createServicesTravellersMap((_p = (_o = (_m = this.orderAfterChange) === null || _m === void 0 ? void 0 : _m.additionalServices) === null || _o === void 0 ? void 0 : _o.nas) === null || _p === void 0 ? void 0 : _p.selectedServices);
        const allProductsIds = new Set([
            ...beforeServicesTravellersIdsMap.keys(),
            ...afterServicesTravellersIdsMap.keys()
        ]);
        allProductsIds.forEach(productId => {
            const nasService = servicesMap.get(productId);
            if (nasService) {
                const beforeTravellersIds = beforeServicesTravellersIdsMap.get(productId) || new Set();
                const afterTravellersIds = afterServicesTravellersIdsMap.get(productId) || new Set();
                afterTravellersIds.forEach(travellerId => {
                    var _a, _b;
                    if (!beforeTravellersIds.has(travellerId)) {
                        added.push(WebskyServicesAnalytics.convertNasServiceToDataLayer(nasService, (_b = (_a = this.orderAfterChange) === null || _a === void 0 ? void 0 : _a.travellers) !== null && _b !== void 0 ? _b : [], travellersMap.get(travellerId).type));
                    }
                });
                beforeTravellersIds.forEach(travellerId => {
                    var _a, _b;
                    if (!afterTravellersIds.has(travellerId)) {
                        removed.push(WebskyServicesAnalytics.convertNasServiceToDataLayer(nasService, (_b = (_a = this.orderAfterChange) === null || _a === void 0 ? void 0 : _a.travellers) !== null && _b !== void 0 ? _b : [], travellersMap.get(travellerId).type));
                    }
                });
            }
        });
        return { added, removed };
    }
}
export default Nas;
